module.exports = __webpack_public_path__ + "static/media/YB5F14_1.642aa8c3.jpg";